
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef, MatDialog as MatDialog, MatDialogContent } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { RecaptchaComponent, RecaptchaModule } from 'ng-recaptcha';
import { environment } from '@env/environment';

/**
 * Services
 */
import { PickImageComponent } from '@shared/components/pick-image/pick-image.component';
import { CrudService } from '@services/laravel/crud.service';
import { ValidateCpf } from '@shared/validators/cpf.validator';
import { DateValidator } from '@shared/validators/date.validator';
import { ValidateRequired } from '@shared/validators/required.validator';
import { ValidateValueComparison } from '@shared/validators/value-comparison.validator';
import { FeedService } from '@services/laravel/feed.service';
import { ToastrService } from 'ngx-toastr';
import { ModalHeaderComponent } from '../../modules/shared/components/modal-header/modal-header.component';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatError, MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { TextMaskDirective } from '../../modules/shared/compat/text-mask.module';
import { MatButton } from '@angular/material/button';

export interface Gender {
  value: string;
  viewValue: string;
}

export interface Detail {
  value: string;
  viewValue: string;
}

@Component({
    standalone: true,
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    imports: [ModalHeaderComponent, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatError, MatFormField, MatLabel, MatInput, MatSelect, MatOption, TextMaskDirective, RecaptchaModule, MatButton]
})

export class RegisterComponent implements OnInit {
  @ViewChild(RecaptchaComponent, { static: false }) captcha: RecaptchaComponent;
  @ViewChild('cropper', { static: false })
  cropper: ImageCropperComponent;

  genders: Gender[] = [
    { value: 'M', viewValue: 'Masculino' },
    { value: 'F', viewValue: 'Feminino' }
  ];

  image_data: any;
  default_image: any = { "image": "data:image/jpeg;base64,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" };
  preview_image_data: any;
  cropperSettings: CropperSettings;

  public mask: any;
  public registerForm: UntypedFormGroup;
  public user: any;
  public drsArray: any;
  public ifExists = false;
  public message = "";
  public token: any;
  public googleData: any;
  public registerRoute: any = 'self-register';
  public isLoading = true;

  constructor(
    private feedService: FeedService,
    private _crud: CrudService,
    private _router: Router,
    public _snackbar: MatSnackBar,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<RegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 100;
    this.cropperSettings.height = 100;
    this.cropperSettings.croppedWidth = 400;
    this.cropperSettings.croppedHeight = 400;
    this.cropperSettings.canvasWidth = 200;
    this.cropperSettings.canvasHeight = 150;

    this.image_data = {};
    this.preview_image_data = this.default_image;
  }

  ngOnInit() {
    this.feedService.listDrs().then((res: any) => { this.drsArray = res; });

    this.user = this.data;

    this.mask = {
      cpf: [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/],
      date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      zip: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
      phone: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      cell_phone: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      cnpj: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    };

    if (this.token) {
      this._crud.get('check-token/' + this.token).then((res: any) => {
        this.isLoading = false;
        if (res.userExists) {
          this.ifExists = true;
          this.dialogRef.updateSize('1000px', '200px');
          this.message = res.message;

        } else {
          this.initInvitationForm(res);
          this.registerRoute = 'create-invited/' + this.token;

          this.registerForm.get('password').setValidators([ValidateValueComparison(this.registerForm.get('repeatPassword'),
            'Campos nova senha e confirme nova senha precisam ter o mesmo valor'), ValidateRequired]);
        }
      }, rej => {
        this.initRegisterForm();
        this.dialogRef.close();
        this.toastr.error(rej['message'], 'Erro!');
      });
    } else {
      this.isLoading = false;
      this.initRegisterForm();
    }

    this.removeCaptchaValidationWhenRunningUnderCI();
  }

  initRegisterForm() {
    this.registerForm = new UntypedFormGroup({
      'name': new UntypedFormControl(null, [ValidateRequired]),
      'email': new UntypedFormControl(null, [Validators.email, ValidateRequired]),
      'avatar_path': new UntypedFormControl(null, [ValidateRequired]),
      'gender': new UntypedFormControl(null, [ValidateRequired]),
      'birth_date': new UntypedFormControl(null, [ValidateRequired, DateValidator]),
      'cpf_number': new UntypedFormControl(null, [ValidateCpf, ValidateRequired]),
      'home_phone': new UntypedFormControl(null, [ValidateRequired]),
      'cell_phone': new UntypedFormControl(null),
      'additional_email': new UntypedFormControl(null),
      'regional': new UntypedFormControl(null, [ValidateRequired]),
      'password': new UntypedFormControl(null, ValidateRequired),
      'repeatPassword': new UntypedFormControl(null, ValidateRequired),
      'captcha': new UntypedFormControl(null, ValidateRequired),
      'google_data': new UntypedFormControl({ value: null, disabled: true }),
    });

    if (this.user) {
      this.registerForm.controls['name'].setValue(this.user.name);
      this.registerForm.controls['email'].setValue(this.user.email);
      this.registerForm.controls['avatar_path'].setValue(this.user.image);
      this.registerForm.controls['cpf_number'].setValue(this.user.cpf_number);
    }

    if (this.data) {
      this.registerForm.controls['google_data'].enable();
      this.registerForm.controls['google_data'].setValue(JSON.stringify(this.data));
    }
  }

  initInvitationForm(res) {
    this.registerForm = new UntypedFormGroup({
      'name': new UntypedFormControl(null, [ValidateRequired]),
      'email': new UntypedFormControl(res.email_invited, [Validators.email, ValidateRequired]),
      'invited_email': new UntypedFormControl(res.email_invited, [Validators.email, ValidateRequired]),
      'avatar_path': new UntypedFormControl(null, [ValidateRequired]),
      'gender': new UntypedFormControl(null, [ValidateRequired]),
      'birth_date': new UntypedFormControl(null, [ValidateRequired]),
      'invited_cpf_number': new UntypedFormControl(res.cpf_number_invited, [ValidateCpf, ValidateRequired]),
      'cpf_number': new UntypedFormControl(res.cpf_number_invited, [ValidateCpf, ValidateRequired]),
      'home_phone': new UntypedFormControl(null, [ValidateRequired]),
      'cell_phone': new UntypedFormControl(null),
      'additional_email': new UntypedFormControl(null),
      'regional': new UntypedFormControl(res.regional_id, [ValidateRequired]),
      'regional_invite': new UntypedFormControl(res.regional_id, [ValidateRequired]),
      'password': new UntypedFormControl(null, ValidateRequired),
      'repeatPassword': new UntypedFormControl(null, ValidateRequired),
      'captcha': new UntypedFormControl(null),
      'access_profiles': new UntypedFormControl(res.invites_profiles),
      'school_id': new UntypedFormControl(res.school_id),
      'course_id': new UntypedFormControl(res.course_id),
      'token': new UntypedFormControl(this.token),
    });

    this.registerForm.controls['cpf_number'].disable();
    this.registerForm.controls['email'].disable();
    this.registerForm.controls['regional'].disable();
  }

  recaptchaExpired() {
    this.registerForm.get('captcha').setValue(null);
  }

  removeCaptchaValidationWhenRunningUnderCI() {
    if (environment.ci) {
      this.registerForm.controls['captcha'].clearValidators();
      this.registerForm.controls['captcha'].disable();
      this.registerForm.updateValueAndValidity();
    }
  }

  close = () => {
    this.dialogRef.close();
  }

  onPickImage = () => {
    const dialogRef = this.dialog.open(PickImageComponent, {
      width: '400px',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.preview_image_data = result;
        this.registerForm.get('avatar_path').setValue(result);
      }

      const array = [];
      const string = '';
    });
  }

  handleCorrectCaptcha($event) {
    this.registerForm.get('captcha').setValue($event);
  }

  convertDate(date) {
    var br_date = date;
    br_date = br_date.split('/');
    var us_date = br_date.reverse().join('-');
    return us_date
  }

  convertDateToBR(date) {
    var br_date = date;
    br_date = br_date.split('-');
    var us_date = br_date.reverse().join('/');
    return us_date
  }

  onRegisterSubmit = () => {
    this.registerForm.get('birth_date').setValue(this.convertDate(this.registerForm.value.birth_date));

    if (this.registerForm.value['access_profiles']) {
      this.registerForm.value["access_profiles"] = this.registerForm.value["access_profiles"].map((value) => {
        return value.id;
      });
    }

    delete this.registerForm.value['repeatPassword'];

    if (!this.registerForm.value['course_id']) {
      delete this.registerForm.value['course_id'];
    }

    if (!this.registerForm.value['school_id']) {
      delete this.registerForm.value['school_id'];
    }

    let objUser = Object.assign({}, this.registerForm.value);

    let formData: any = new FormData();

    for (var key in objUser) {
      formData.append(key, objUser[key]);
    }

    const params = {
      route: this.registerRoute,
      objectToCreate: formData
    };

    this._crud.post(this.registerRoute, params.objectToCreate)
      .then(res => {
        if (this.token) {
          this.toastr.success("Usuário Cadastrado com Sucesso!");
        } else {
          this.toastr.success("Procure o Coordernador de Avaliação da sua escola ou Interlocutor Regional para validação do seu cadastro!");
        }

        this.close();
      });
    this.registerForm.get('birth_date').setValue(this.convertDateToBR(this.registerForm.value.birth_date));
  }

  isContinuosIntegration() {
    return environment.ci;
  }
}
